<div class="auth-page">
  <div class="auth-card">
    <div class="auth-card-inner">
      <div class="auth-visual">
        <p class="auth-visual-kicker">Appstrax</p>
        @if (authStep != null) {
          <ol class="auth-step-indicator" aria-label="Setup progress">
            @for (s of setupSteps; track s) {
              <li [class.is-active]="authStep >= s"></li>
            }
          </ol>
        }
        <h1 class="auth-visual-title">Verify Email</h1>
        <p class="auth-visual-subtitle">to get started</p>
        <div class="auth-visual-deco" aria-hidden="true"></div>
      </div>

      <div class="auth-form">
        <h2 class="auth-form-title">Welcome!</h2>
        <p class="auth-form-lead">Verify your email</p>

        <form (ngSubmit)="verifyEmail()" #form="ngForm" autocomplete="off">
          <div class="form-group">
            <label for="code" class="visually-hidden">Code</label>
            <div class="input-with-icon">
              <i class="bi bi-code"></i>
              <input
                type="text"
                class="form-control"
                id="code"
                name="code"
                [(ngModel)]="code"
                placeholder="Code"
                required
              />
            </div>
          </div>

          @if (errorMessage) {
            <div class="alert alert-danger mb-3">
              {{ errorMessage }}
            </div>
          }

          <button
            class="btn btn-primary auth-submit"
            type="submit"
            [disabled]="!isFormValid()"
            [ngClass]="{ disabled: isLoading }"
          >
            @if (isLoading) {
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            }
            <span class="ms-2" role="status">Verify email</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
